// extracted by mini-css-extract-plugin
export default {"wrap":"sr-z","searchHeaderWrap":"tr-z","melodyCategory":"ur-z","fullWidth":"vr-z","items":"wr-z","featureCss":"xr-z","disabled":"yr-z","imgCss":"zr-z"};